import React, { useState } from 'react';
import Seo from '../components/Seo';
import { X } from 'lucide-react';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import { galleryImages } from '../mock/mock';

const filters = ['All', 'Facility', 'Warehouse', 'Packing', 'Shipping'];

const Gallery = () => {
  const [active, setActive] = useState('All');
  const [lightbox, setLightbox] = useState(null);

  const items = active === 'All' ? galleryImages : galleryImages.filter((g) => g.category === active);

  return (
    <div>
      <Seo title="Gallery — Our Mill, Products & Shipments" description="Photos from Kassam Trading Company's rice mill at Port Qasim, our product range, packaging and export shipments to markets worldwide." path="/gallery" />
      <PageHero
        title="Gallery"
        subtitle="Inside our processing plant, warehouse, packing lines and shipments at Port Qasim."
        crumb="Gallery"
      />

      <section className="max-w-7xl mx-auto px-6 py-14">
        <div className="flex items-center gap-2 flex-wrap mb-10">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setActive(f)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${active === f ? 'bg-ktc-green text-ktc-ivory' : 'bg-ktc-cream/70 text-ktc-charcoal/75 hover:bg-ktc-cream'}`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {items.map((g, i) => (
            <Reveal key={g.src + i} delay={(i % 3) * 60} className="mb-5 break-inside-avoid">
              <button onClick={() => setLightbox(g)} className="group block w-full text-left rounded-xl overflow-hidden img-zoom card-lift bg-ktc-ivoryLight border border-ktc-cream">
                <div className="overflow-hidden">
                  <img src={g.src} alt={g.caption} className="w-full object-cover" loading="lazy" />
                </div>
                <div className="p-4 flex items-center justify-between">
                  <span className="font-serif text-lg text-ktc-green">{g.caption}</span>
                  <span className="text-[11px] uppercase tracking-wider text-ktc-gold font-semibold">{g.category}</span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      {lightbox && (
        <div className="fixed inset-0 z-[60] bg-ktc-greenDark/95 flex items-center justify-center p-6" onClick={() => setLightbox(null)}>
          <button className="absolute top-6 right-6 text-ktc-ivory hover:text-ktc-goldLight" onClick={() => setLightbox(null)}><X size={30} /></button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={lightbox.src} alt={lightbox.caption} className="w-full max-h-[78vh] object-contain rounded-lg" />
            <p className="text-center text-ktc-ivory/85 font-serif text-xl mt-4">{lightbox.caption}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
